import './modules/detect';
import './modules/polyfills';
import './modules/accordion';
// import './modules/personalisation-modal';
import './modules/nav';
import './modules/nav/mobile';
import './modules/swiper';
import './modules/post-progress';
import './modules/post-title';
import './modules/social-share';
import './modules/maps';
import './modules/forms/search';
import './modules/forms/radio';
import './modules/search-menu';
import './modules/search';
import './modules/search-scroll';
import './modules/forms/select-clearable';
import './modules/forms/select-sortable';
import './modules/secondary-nav';
import './modules/reframe';
import './modules/tabs';
import './modules/segments';
import './modules/action-bar';
import siteNotification from './modules/site-notification';
import './modules/newsroom-internal-referer';
import './modules/hero-modal';
import './modules/hero';
import './modules/interactive-map';
import './modules/ie-image-flex';
import segmentFormTracking from './modules/segment/form-tracking';
import './modules/careers-listings';
import './modules/button';
import './modules/sector-buttons';

siteNotification();

window.onload = () => {
  /**
   * Set up tracking for Hubspot forms.
   */
  const hubspotForm = document.querySelector('.hbspt-form form');

  if (hubspotForm) {
    segmentFormTracking().init(hubspotForm, {
      eventName: 'form_submitted',
      formFields: [
        { id: 'first_name', input: '[name="firstname"]' },
        { id: 'last_name', input: '[name="lastname"]' },
        { id: 'email', input: '[name="email"]' },
        { id: 'phone', input: '[name="phone"]' },
        { id: 'company', input: '[name="company"]' },
        { id: 'job_title', input: '[name="job_title"]' },
        { id: 'company_fca_number', input: '[name="company_fca_number"]' },
        { id: 'individual_fca_number', input: '[name="individual_fca_number"]' },
        { id: 'company_postcode', input: '[name="zip"]' },
      ],
      extraData: {
        form_id: hubspotForm.getAttribute('id'),
      },
    });
  }

  /**
   * Inject link colour override if hubspot form is in a dark section.
   */
  const hubspotFormContainer = document.querySelector('.hbspt-form');

  if (hubspotFormContainer) {
    const darkSection = hubspotFormContainer.closest('.section--tinted-dark');

    // Make sure there is a dark section, and double check the hubspot form is inside.
    if (darkSection && darkSection.contains(hubspotFormContainer)) {
      const iframe = document.querySelector('.hs-form-iframe');
      const iframeContent = iframe?.contentDocument;

      if (iframeContent) {
        const styleEL = document.createElement('style');

        styleEL.innerHTML = '.hbspt-form, p, a { color: white !important; }';
        iframeContent.head.appendChild(styleEL);
      }
    }
  }
};
